import { render, staticRenderFns } from "./resizeContainer.vue?vue&type=template&id=4167ec22&scoped=true"
import script from "./resizeContainer.vue?vue&type=script&lang=js"
export * from "./resizeContainer.vue?vue&type=script&lang=js"
import style0 from "./resizeContainer.vue?vue&type=style&index=0&id=4167ec22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167ec22",
  null
  
)

export default component.exports